import { createV3Queries } from "@query/utils/createV3Queries";
import { worksitesApi } from "@api";

/**
 * Work-site registry — mirrors `WorksitesApi` 1:1. Work sites are account-level
 * settings (a W-2 requirement: every engagement that isn't remote points at one
 * via `Engagement.worksiteId`), so the name-derived defaults refreshing
 * `getWorksite` / `listWorksites` after each write are exactly what we want.
 */
export const queriesWorksites = createV3Queries("worksitesApi", worksitesApi);
